import React from "react";

import { Link } from "react-router-dom";
import { semanticBackgroundClasses } from "../../theme/semanticClasses";
import SvgIcon, { SvgIconType } from "../../helpers/SvgIcon";

type Props = {
  title?: string;
  icon?: SvgIconType;
  className?: string;
  color?: string;
  subtitle?: string;
  subtitleValue?: string | number;
  children?: React.ReactNode;
  navigationLinks?: { link: string; label: string }[];
};

const MenuHeaderCategory = ({
  title,
  icon,
  className = "",
  color = "primary",
  subtitle,
  subtitleValue,
  navigationLinks,
}: Props) => {
  const colorClasses =
    color === "primary"
      ? "bg-[#2196f3] text-white"
      : semanticBackgroundClasses[color] ?? semanticBackgroundClasses.primary;
  return (
    <div
      className={`min-h-[175px] w-full rounded-card px-9 pb-7 pt-7 ${colorClasses} ${className}`}>
      <div className="flex w-full items-center justify-between">
        <div className="flex min-w-0 items-center gap-3 text-white">
          {icon && (
            <span
              aria-hidden="true"
              className="inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-control bg-surface-subtle text-muted-dark [&_svg]:!h-8 [&_svg]:!w-8">
              <SvgIcon type={icon} fill="currentColor" />
            </span>
          )}
          <h2 className="m-0 break-words text-[1.35rem] font-semibold text-white">
            {title}
          </h2>
        </div>
        {!!navigationLinks && (
          <div className="flex gap-2">
            {navigationLinks.map(({ link, label }, index: number) => (
              <Link
                key={index}
                to={link}
                className="rounded-control bg-white px-3 py-2 font-medium text-slate-900 shadow-xs transition hover:bg-surface-hover">
                {label}
              </Link>
            ))}
          </div>
        )}
      </div>
      {subtitle && subtitleValue && (
        <div className="flex flex-col pt-8 text-center text-white">
          <span className="text-base font-medium">{subtitle}</span>
          <span className="pt-1 text-2xl font-semibold">{subtitleValue}</span>
        </div>
      )}
      <div className="h-[100px]" />
    </div>
  );
};

export default MenuHeaderCategory;
